import type {
  GameQuizKind,
  GameWithTags,
} from "../../../services/gameQuiz/gameQuiz.types";

export const QUIZ_KIND_OPTIONS: { value: GameQuizKind; label: string }[] = [
  { value: "NORMAL", label: "Normal" },
  { value: "EXAM", label: "Examen" },
];

const hasPositivePoints = (game: GameWithTags): boolean =>
  typeof game.points === "number" && game.points > 0;

const hasCourse = (game: GameWithTags): boolean =>
  Number.isInteger(game.course_id) && (game.course_id ?? 0) > 0;

export function findExamQuestionError(games: GameWithTags[]): string | null {
  const index = games.findIndex(
    (game) => !hasPositivePoints(game) || !hasCourse(game),
  );
  if (index === -1) return null;
  const missing = hasPositivePoints(games[index])
    ? "el curso que evalúa"
    : "un puntaje mayor que 0";
  return `La pregunta #${index + 1} del examen necesita ${missing}.`;
}

export function gamesForKind(
  games: GameWithTags[],
  kind: GameQuizKind,
): GameWithTags[] {
  if (kind === "EXAM") return games;
  return games.map(
    ({
      points: _points,
      course_id: _courseId,
      situation_id: _situationId,
      ...game
    }) => ({
      ...game,
    }),
  ) as GameWithTags[];
}
